import { TServiceCookie } from 'features/product-info/components/pdp-select-tint-color';

type TProps = {
  servicesFromCookie: (TServiceCookie | never)[];
  color: string;
};

export const getServicesWithoutTintServiceForActiveColor = ({ servicesFromCookie, color }: TProps) => {
  return servicesFromCookie.filter((service) => {
    return (
      ('color' in service.parameters && service.parameters.color !== color) ||
      !('color' in service.parameters)
    );
  });
};
